/** Document styles */
export const documentStyles = {
    container: {
        backgroundColor: 'transparent',
        height: 'calc(100%)',
        boxSizing: 'border-box',
        width: '100%',
        '& *': { minWidth: '0', minHeight: '0' },
    },
    mobileIconButton: {
        backgroundColor: 'blueLight.main',
        zIndex: '10',
        color: 'blackDark.main'
    },
};
